/* =====================================================================
   PRODUCT PAGE — v4 "density polished" behaviour
   ---------------------------------------------------------------------
   Ported from car-dog-hammock-v4-density-polished.html, with four
   changes the live store needs:

   1. NO MEDIA_PREVIEW. The mock rendered a "PREVIEW" card wherever a
      video slot had no src, so the author could see the page rhythm
      before filming. On a real storefront a placeholder that says
      PREVIEW is worse than no section, so the template renders a slot
      only when the product actually has that video attached, and this
      file just wires playback.

   2. REVIEWS COME FROM SHOPIFY, not a hand-edited array. The template
      writes the `custom.reviews` metafield into window.__pdp4Reviews.
      No entry, no section, and never an invented rating.

   3. ADD TO CART GOES THROUGH THE THEME'S CART. theme.js owns the cart
      drawer, the item count, the bundle offer and the AJAX add; this
      file hands off to it so every add-to-cart on the page behaves the
      same as the rest of the site. If that global is missing it posts
      to /cart/add.js itself, and if that fails it lets the form submit
      natively — the button can never become a dead end.

   4. theme.js stays out of the way. Its PDP handlers key off ids this
      page does not use (#gal-track, #rev-track, #fit-form, #sticky-add,
      #buy as a form), so they all bail out at their first query. The
      buy panel here is #buypanel for exactly that reason.
   ===================================================================== */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  var root = $('.pdp4');
  if (!root) return;

  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  };

  /* ============ 1 · VIDEO PLAYBACK ============ */
  /* Play at ~50% visible, pause offscreen. Never autoplays under
     prefers-reduced-motion — the loop is decoration, not content. */
  (function () {
    var vids = $$('.vslot video', root);
    if (!vids.length) return;
    if (RM) { vids.forEach(function (v) { v.removeAttribute('loop'); v.pause(); }); return; }
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting && e.intersectionRatio >= 0.5) { e.target.play().catch(function () {}); }
        else { e.target.pause(); }
      });
    }, { threshold: [0, 0.5, 1] });
    vids.forEach(function (v) { io.observe(v); });
  }());

  /* ============ 2 · SCROLL PROGRESS ============ */
  (function () {
    var bar = $('#progress', root);
    if (!bar || RM) return;
    var queued = false;
    function paint() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.width = (h > 0 ? Math.min(100, window.scrollY / h * 100) : 0) + '%';
      queued = false;
    }
    window.addEventListener('scroll', function () {
      if (!queued) { queued = true; requestAnimationFrame(paint); }
    }, { passive: true });
    paint();
  }());

  /* ============ 3 · SCROLL REVEALS ============ */
  /* Sections are visible by default and only made transparent once this
     script has confirmed it can reveal them again (html.pdp4-js), so a
     blocked or failed script can never leave the page blank. */
  (function () {
    var items = $$('.rv,.rv-img', root);
    if (!items.length || !('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('pdp4-js');
    if (RM) { items.forEach(function (i) { i.classList.add('in'); }); return; }
    $$('[data-stagger]', root).forEach(function (g) {
      $$('.rv,.rv-img', g).forEach(function (c, i) { c.style.setProperty('--d', (i * 75) + 'ms'); });
    });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (i) { io.observe(i); });
  }());

  /* ============ 4 · PRODUCT CAROUSEL ============ */
  (function () {
    var track = $('#gTrack', root);
    if (!track) return;
    var slides = $$('.slide', track);
    if (!slides.length) return;

    var dotsBox = $('#gDots', root), thumbsBox = $('#gThumbs', root),
        capEl = $('#gCap', root), idxEl = $('#gIdx', root),
        prev = $('#gPrev', root), next = $('#gNext', root);
    var idx = 0;

    slides.forEach(function (s, i) {
      var d = document.createElement('span');
      d.className = 'dot';
      if (!i) d.setAttribute('aria-current', 'true');
      dotsBox.appendChild(d);

      var t = document.createElement('button');
      t.type = 'button';
      t.className = 'thumb';
      t.setAttribute('role', 'tab');
      t.setAttribute('aria-label', 'Image ' + (i + 1));
      if (!i) t.setAttribute('aria-current', 'true');

      /* A video slide has no <img>; use its poster, and fall back to a
         labelled play tile so the rail never shows an empty square. */
      var img = s.querySelector('img'), vid = s.querySelector('video');
      var src = vid ? (vid.getAttribute('poster') || '') : (img ? img.getAttribute('src') : '');
      if (src) {
        var ti = document.createElement('img');
        ti.src = src; ti.alt = ''; ti.loading = 'lazy'; ti.decoding = 'async';
        t.appendChild(ti);
      } else {
        var m = document.createElement('span');
        m.className = 'mini';
        m.innerHTML = '<span class="tri">&#9654;</span>' + esc(s.dataset.thumb || (i + 1));
        t.appendChild(m);
      }
      t.addEventListener('click', function () { go(i); });
      thumbsBox.appendChild(t);
    });

    var dots = $$('.dot', dotsBox), thumbs = $$('.thumb', thumbsBox);
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };

    function go(i) {
      idx = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: RM ? 'auto' : 'smooth' });
    }

    function sync() {
      var best = 0, min = Infinity, tl = track.getBoundingClientRect().left;
      slides.forEach(function (s, i) {
        var d = Math.abs(s.getBoundingClientRect().left - tl);
        if (d < min) { min = d; best = i; }
      });
      idx = best;
      dots.forEach(function (d, i) { i === idx ? d.setAttribute('aria-current', 'true') : d.removeAttribute('aria-current'); });
      thumbs.forEach(function (t, i) { i === idx ? t.setAttribute('aria-current', 'true') : t.removeAttribute('aria-current'); });
      slides.forEach(function (s, i) { s.classList.toggle('active', i === idx); });
      if (capEl) capEl.textContent = slides[idx].dataset.caption || '';
      if (idxEl) idxEl.textContent = pad(idx + 1) + ' / ' + pad(slides.length);
      if (prev) prev.disabled = idx === 0;
      if (next) next.disabled = idx === slides.length - 1;
    }

    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf); raf = requestAnimationFrame(sync);
    }, { passive: true });
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
    });
    sync();

    /* pointer parallax, max ~4px, desktop only */
    if (!RM && FINE) {
      track.addEventListener('pointermove', function (e) {
        var r = track.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width - 0.5) * 2;
        var y = ((e.clientY - r.top) / r.height - 0.5) * 2;
        var s = slides[idx];
        if (!s) return;
        s.style.setProperty('--px', (x * 4).toFixed(2) + 'px');
        s.style.setProperty('--py', (y * 4).toFixed(2) + 'px');
      }, { passive: true });
      track.addEventListener('pointerleave', function () {
        slides.forEach(function (s) { s.style.setProperty('--px', '0px'); s.style.setProperty('--py', '0px'); });
      });
    }

    /* "See your dog settle in" pill — only if that video slide exists */
    var jump = $('#jumpVideo', root);
    if (jump) {
      var target = -1;
      slides.forEach(function (s, i) { if (target < 0 && s.querySelector('.vslot')) target = i; });
      var social = $('#social', root);
      if (target > -1) {
        jump.classList.add('on');
        jump.addEventListener('click', function () { go(target); });
      } else if (social) {
        /* no video in the gallery: the pill takes you to the real-car videos */
        jump.classList.add('on');
        jump.addEventListener('click', function () {
          social.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' });
        });
      }
    }
  }());

  /* ============ 4b · SOCIAL PROOF VIDEOS ============ */
  /* Muted loops that play while on screen. Tapping one turns its sound on and
     mutes the others, so two clips never talk over each other. */
  (function () {
    var cards = $$('.ugc-media', root);
    if (!cards.length) return;
    var vids = cards.map(function (c) { return c.querySelector('video'); });
    if (!RM && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting && e.intersectionRatio >= 0.5) {
            if (v.preload === 'none') v.preload = 'auto';
            v.play().catch(function () {});
          } else { v.pause(); }
        });
      }, { threshold: [0, 0.5, 1] });
      vids.forEach(function (v) { if (v) io.observe(v); });
    }
    cards.forEach(function (c, i) {
      var v = vids[i];
      if (!v) return;
      c.addEventListener('click', function () {
        var turnOn = v.muted;
        vids.forEach(function (o, j) {
          if (!o) return;
          o.muted = true;
          cards[j].setAttribute('aria-pressed', 'false');
          cards[j].classList.remove('is-sound');
        });
        if (turnOn) {
          v.muted = false;
          v.play().catch(function () {});
          c.setAttribute('aria-pressed', 'true');
          c.classList.add('is-sound');
        }
      });
    });
  }());

  /* ============ 5 · HOTSPOTS ============ */
  (function () {
    var tips = [];
    $$('.hs-wrap', root).forEach(function (wrap) {
      $$('.hs', wrap).forEach(function (h) {
        h.style.left = h.dataset.x + '%';
        h.style.top = h.dataset.y + '%';
        var tip = document.createElement('span');
        tip.className = 'hs-tip';
        tip.textContent = h.dataset.tip;
        tip.style.left = h.dataset.x + '%';
        tip.style.top = h.dataset.y + '%';
        wrap.appendChild(tip);
        tips.push(tip);
        function open() {
          tips.forEach(function (t) { t.classList.remove('on'); });
          tip.classList.add('on');
          h.setAttribute('aria-expanded', 'true');
        }
        function close() { tip.classList.remove('on'); h.setAttribute('aria-expanded', 'false'); }
        h.addEventListener('mouseenter', open);
        h.addEventListener('mouseleave', close);
        h.addEventListener('focus', open);
        h.addEventListener('blur', close);
        h.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          tip.classList.contains('on') ? close() : open();
        });
      });
    });
    if (tips.length) {
      document.addEventListener('click', function () { tips.forEach(function (t) { t.classList.remove('on'); }); });
    }
  }());

  /* ============ 6 · BENEFIT SELECTOR ============ */
  (function () {
    var tabs = $$('.mud-tab', root), ans = $('#mudAnswer', root), img = $('#mudImg', root);
    if (!tabs.length || !ans) return;
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (o) { o.setAttribute('aria-selected', 'false'); });
        t.setAttribute('aria-selected', 'true');
        ans.classList.add('swap');
        setTimeout(function () {
          ans.textContent = t.dataset.ans;
          ans.classList.remove('swap');
        }, RM ? 0 : 180);
        if (img && !RM) {
          if (t.dataset.zoom) img.style.transform = 'scale(' + t.dataset.zoom + ')';
          if (t.dataset.pos) img.style.objectPosition = t.dataset.pos;
        }
      });
    });
  }());

  /* ============ 7 · CHAPTER SELECTORS ============ */
  function chapters(listSel, videoSel) {
    var items = $$(listSel + ' [role="tab"]', root);
    if (!items.length) return;
    var slot = videoSel ? $(videoSel, root) : null;
    function select(el) {
      items.forEach(function (i) { i.setAttribute('aria-selected', 'false'); });
      el.setAttribute('aria-selected', 'true');
      var t = el.dataset.time, v = slot && slot.querySelector('video');
      if (v && t !== '' && t != null && !isNaN(parseFloat(t))) {
        try { v.currentTime = parseFloat(t); } catch (e) {}
      }
    }
    items.forEach(function (el) {
      el.addEventListener('click', function () { select(el); });
      if (window.matchMedia('(hover:hover)').matches) {
        el.addEventListener('mouseenter', function () { select(el); });
      }
    });
  }
  chapters('#instSteps', '#instVideo');
  chapters('#cleanStates', null);

  /* cleaning states advance with the scroll — no scroll-jacking */
  (function () {
    var states = $$('#cleanStates [role="tab"]', root);
    if (!states.length || RM) return;
    var sec = states[0].closest('section');
    if (!sec) return;
    var queued = false;
    function upd() {
      var r = sec.getBoundingClientRect();
      var p = Math.max(0, Math.min(1, (window.innerHeight * 0.75 - r.top) / (r.height * 0.75)));
      var i = Math.min(states.length - 1, Math.floor(p * states.length));
      states.forEach(function (s, n) { s.setAttribute('aria-selected', n === i ? 'true' : 'false'); });
      queued = false;
    }
    window.addEventListener('scroll', function () {
      if (!queued) { queued = true; requestAnimationFrame(upd); }
    }, { passive: true });
    upd();
  }());

  /* ============ 8 · FIT CHECKER — 2-step wizard ============ */
  (function () {
    var box = $('#fitChecker', root);
    if (!box) return;
    var s1 = $('#fcStep1', root), s2 = $('#fcStep2', root), s3 = $('#fcStep3', root),
        prog = $('#fcProg', root), title = $('#fcTitle', root), out = $('#fcResult', root);
    var state = { vehicle: null, headrests: null };
    var wait = RM ? 0 : 260;
    var contact = box.dataset.contact || '/pages/contact';

    function show(step, label, heading) {
      [s1, s2, s3].forEach(function (p) { p.classList.remove('on', 'in'); });
      step.classList.add('on');
      requestAnimationFrame(function () { step.classList.add('in'); });
      prog.textContent = label;
      title.textContent = heading;
    }

    $$('#fcCars .fc-car', root).forEach(function (c) {
      c.addEventListener('click', function () {
        $$('#fcCars .fc-car', root).forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
        c.setAttribute('aria-pressed', 'true');
        state.vehicle = c.dataset.v;
        setTimeout(function () { show(s2, '2 OF 2', box.dataset.q2 || 'One more question'); }, wait);
      });
    });

    $$('#fcHead .fc-opt', root).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('#fcHead .fc-opt', root).forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        state.headrests = b.dataset.v;
        setTimeout(result, wait);
      });
    });

    $('#fcBack', root).addEventListener('click', function () { show(s1, '1 OF 2', box.dataset.q1 || ''); });
    $('#fcRestart', root).addEventListener('click', function () {
      state.vehicle = null; state.headrests = null;
      $$('#fcCars .fc-car', root).forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
      $$('#fcHead .fc-opt', root).forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
      show(s1, '1 OF 2', box.dataset.q1 || '');
    });

    function result() {
      /* "Likely", never "guaranteed" — the checker asks two questions and
         cannot know the car. Anything short of both clear answers routes
         to a human rather than guessing. */
      var likely = state.vehicle === 'ok' && state.headrests === 'yes';
      out.className = 'fc-result' + (likely ? ' good' : '');
      out.innerHTML = likely
        ? '<b><span class="ck" aria-hidden="true">✓</span>' + esc(box.dataset.okTitle || 'Looks like a likely fit.') + '</b>' +
          '<p>' + esc(box.dataset.okBody || '') + '</p>' +
          '<div class="fc-acts">' +
            '<a class="main" href="#dimensions">See dimensions ↓</a>' +
            '<a class="sub" href="' + esc(contact) + '">' + esc(box.dataset.askLabel || 'Still unsure? Ask us.') + '</a>' +
          '</div>'
        : '<b>' + esc(box.dataset.checkTitle || 'Let’s double-check.') + '</b>' +
          '<p>' + esc(box.dataset.checkBody || '') + '</p>' +
          '<div class="fc-acts"><a class="main" href="' + esc(contact) + '">' + esc(box.dataset.checkLabel || box.dataset.askLabel || 'Ask us →') + '</a></div>';
      show(s3, likely ? 'DONE' : 'ONE MORE STEP', likely ? 'Good news' : 'Let’s check together');
    }
  }());

  /* ============ 9 · BEFORE / AFTER SLIDER ============ */
  (function () {
    var ba = $('#ba', root), range = $('#baRange', root);
    if (!ba || !range) return;
    /* the range input gives mouse drag, touch drag and arrow keys for free */
    function set(v) { ba.style.setProperty('--pos', v + '%'); }
    range.addEventListener('input', function () { set(range.value); });
    set(range.value);
  }());

  /* ============ 10 · REVIEWS ============ */
  (function () {
    var track = $('#revTrack', root), foot = $('#revFoot', root), dotsBox = $('#revDots', root),
        prev = $('#revPrev', root), next = $('#revNext', root);
    if (!track) return;

    var data = Array.isArray(window.__pdp4Reviews) ? window.__pdp4Reviews : [];
    var live = data.filter(function (r) {
      return r && (String(r.text || '').trim() || String(r.title || '').trim() || String(r.image || '').trim());
    });
    /* The section is not rendered at all when the metafield is empty, so
       reaching here with nothing means bad data rather than no data. */
    if (!live.length) { if (foot) foot.style.display = 'none'; return; }

    track.innerHTML = live.map(function (r) {
      var n = Math.max(0, Math.min(5, parseInt(r.stars, 10) || 0));
      return '<article class="rev-card">' +
        (r.image ? '<div class="rev-photo"><img src="' + esc(r.image) + '" alt="" loading="lazy" decoding="async"></div>' : '') +
        '<div class="rev-body">' +
          '<div class="rev-stars" aria-label="Rated ' + n + ' out of 5">' +
            '★'.repeat(n) + '☆'.repeat(5 - n) + '</div>' +
          (r.title ? '<h3 class="rev-title">' + esc(r.title) + '</h3>' : '') +
          (r.text ? '<p class="rev-text">' + esc(r.text) + '</p>' : '') +
          '<div class="rev-meta">' +
            (r.name ? '<b>' + esc(r.name) + '</b>' : '') +
            (r.details ? '<span class="rev-details">' + esc(r.details) + '</span>' : '') +
            (r.date ? '<span class="date">' + esc(r.date) + '</span>' : '') +
            (r.verified ? '<span class="verified">✓ Verified purchase</span>' : '') +
          '</div>' +
        '</div></article>';
    }).join('');

    var cards = $$('.rev-card', track);
    cards.forEach(function (_, i) {
      var s = document.createElement('span');
      if (!i) s.setAttribute('aria-current', 'true');
      dotsBox.appendChild(s);
    });
    var dots = $$('span', dotsBox);

    function step(dir) {
      var c = cards[0];
      if (!c) return;
      track.scrollBy({ left: dir * (c.getBoundingClientRect().width + 14), behavior: RM ? 'auto' : 'smooth' });
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });

    var raf;
    function sync() {
      var best = 0, min = Infinity, tl = track.getBoundingClientRect().left;
      cards.forEach(function (c, i) {
        var d = Math.abs(c.getBoundingClientRect().left - tl);
        if (d < min) { min = d; best = i; }
      });
      dots.forEach(function (d, i) { i === best ? d.setAttribute('aria-current', 'true') : d.removeAttribute('aria-current'); });
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    sync();

    /* drag to scroll, pointer devices only */
    var down = false, sx = 0, sl = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true; sx = e.clientX; sl = track.scrollLeft; track.classList.add('dragging');
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      track.scrollLeft = sl - (e.clientX - sx);
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false; track.classList.remove('dragging');
    });

    /* rating row + sticky stars, from real order-backed data only */
    var rated = live.filter(function (r) { return parseInt(r.stars, 10) > 0; });
    if (!rated.length) return;
    var avg = rated.reduce(function (s, r) { return s + parseInt(r.stars, 10); }, 0) / rated.length;
    var whole = Math.round(avg);
    var rowStars = $('#ratingStars', root), rowVal = $('#ratingVal', root), rowN = $('#ratingN', root);
    if (rowStars) rowStars.textContent = '★'.repeat(whole) + '☆'.repeat(5 - whole);
    if (rowVal) rowVal.textContent = (Math.round(avg * 10) / 10).toFixed(1);
    var row = $('#ratingRow', root);
    var totalAttr = row && row.getAttribute('data-total');
    var shown = totalAttr && totalAttr.trim() ? totalAttr.trim() : String(rated.length);
    if (rowN) rowN.textContent = '· ' + shown + (shown === '1' ? ' review' : ' reviews');
    if (row) row.classList.remove('rating--empty');
    var ss = $('#stickyStars', root);
    if (ss && window.innerWidth >= 380) { ss.textContent = '★'.repeat(whole); ss.classList.add('on'); }
  }());

  /* ============ 11 · FAQ ============ */
  (function () {
    var all = $$('#faq details', root);
    if (!all.length) return;
    all.forEach(function (d) {
      var inner = d.querySelector('.faq-inner');
      if (!inner) return;
      inner.style.height = d.open ? 'auto' : '0px';
      d.querySelector('summary').addEventListener('click', function (e) {
        e.preventDefault();
        var opening = !d.open;
        if (opening && window.innerWidth < 900) {
          all.forEach(function (o) {
            if (o === d || !o.open) return;
            var oi = o.querySelector('.faq-inner');
            oi.style.height = oi.scrollHeight + 'px';
            requestAnimationFrame(function () { oi.style.height = '0px'; });
            setTimeout(function () { o.open = false; }, 340);
          });
        }
        if (opening) {
          d.open = true;
          inner.style.height = '0px';
          requestAnimationFrame(function () { inner.style.height = inner.scrollHeight + 'px'; });
          setTimeout(function () { if (d.open) inner.style.height = 'auto'; }, 360);
        } else {
          inner.style.height = inner.scrollHeight + 'px';
          requestAnimationFrame(function () { inner.style.height = '0px'; });
          setTimeout(function () { d.open = false; }, 340);
        }
      });
    });
  }());

  /* ============ 12 · VARIANT PICKER ============ */
  /* Both current products are single-variant, so the template renders no
     picker at all. This runs only if one ever gains options. */
  (function () {
    var sel = $('#variant-select', root);
    if (!sel) return;
    var opts = $$('.opt', root);
    function apply() {
      var chosen = opts.filter(function (o) { return o.getAttribute('aria-pressed') === 'true'; })
        .map(function (o) { return o.dataset.value; });
      var match = Array.prototype.slice.call(sel.options).filter(function (o) {
        return chosen.every(function (v) { return (o.dataset.title || '').split(' / ').indexOf(v) > -1; });
      })[0];
      if (!match) return;
      sel.value = match.value;
      $$('input[name="id"]', root).forEach(function (i) { i.value = match.value; });
      $$('[data-price-now]', root).forEach(function (el) { el.textContent = match.dataset.price; });
      $$('.cta[data-label]', root).forEach(function (b) {
        b.dataset.label = 'Add to cart — ' + match.dataset.price;
        if (!b.dataset.state) b.textContent = b.dataset.label;
      });
    }
    opts.forEach(function (o) {
      o.addEventListener('click', function () {
        opts.filter(function (x) { return x.dataset.option === o.dataset.option; })
          .forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        o.setAttribute('aria-pressed', 'true');
        apply();
      });
    });
  }());

  /* ============ 13 · ADD TO CART ============ */
  (function () {
    $$('.product-form', root).forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var btn = form.querySelector('.cta');
        var input = form.querySelector('input[name="id"]');
        if (!btn || !input || !input.value) return;
        e.preventDefault();

        var label = btn.dataset.label || btn.textContent;
        btn.dataset.state = 'loading';
        btn.textContent = 'Adding…';

        function done() {
          btn.dataset.state = 'done';
          btn.textContent = '✓ Added to cart';
          setTimeout(function () { btn.removeAttribute('data-state'); btn.textContent = label; }, 2200);
        }
        function fallbackSubmit() {
          btn.removeAttribute('data-state');
          btn.textContent = label;
          HTMLFormElement.prototype.submit.call(form);
        }

        /* theme.js owns the drawer, the count badge and the bundle offer */
        if (typeof Cart !== 'undefined' && Cart && typeof Cart.add === 'function') {
          Cart.add([input.value]).then(done).catch(fallbackSubmit);
          return;
        }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(input.value), quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
          .then(done)
          .catch(fallbackSubmit);
      });
    });
  }());

  /* ============ 14 · STICKY BAR ============ */
  (function () {
    var buy = $('#buypanel', root), bar = $('#sticky', root);
    if (!buy || !bar || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        bar.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }, { threshold: 0 }).observe(buy);
  }());

  /* ============ 15 · CURSOR LABEL ============ */
  (function () {
    var tag = $('#cursorTag', root);
    if (!tag || RM || !FINE) return;
    $$('[data-cursor]', root).forEach(function (el) {
      el.addEventListener('pointerenter', function () { tag.textContent = el.dataset.cursor; tag.classList.add('on'); });
      el.addEventListener('pointerleave', function () { tag.classList.remove('on'); });
      el.addEventListener('pointermove', function (e) {
        tag.style.left = e.clientX + 'px';
        tag.style.top = e.clientY + 'px';
      }, { passive: true });
    });
  }());

  /* ============ 16 · NOMINATE A RESCUE ============ */
  (function () {
    var ov = $('#nomOv', root), openBtn = $('#nomOpen', root), modal = $('#nomModal', root),
        form = $('#nomForm', root), wrap = $('#nomFormWrap', root), done = $('#nomDone', root),
        err = $('#nomError', root), submit = $('#nomSubmit', root), body = $('#nomBody', root);
    if (!ov || !openBtn || !form) return;
    var lastFocus = null, sending = false;

    function focusables() {
      return $$('button:not([disabled]), input:not([type=hidden]), a[href]', modal)
        .filter(function (el) { return el.offsetParent !== null; });
    }
    function open() {
      lastFocus = document.activeElement;
      ov.hidden = false;
      requestAnimationFrame(function () { ov.classList.add('open'); });
      document.body.classList.add('is-locked');
      var f = $('#rescueName', root);
      if (f) setTimeout(function () { f.focus(); }, RM ? 0 : 180);
    }
    function close() {
      ov.classList.remove('open');
      document.body.classList.remove('is-locked');
      setTimeout(function () {
        ov.hidden = true;
        wrap.hidden = false; done.hidden = true; form.reset();
        err.classList.remove('on'); err.textContent = '';
        submit.disabled = false; submit.textContent = 'Send nomination';
        sending = false;
      }, RM ? 0 : 240);
      if (lastFocus) lastFocus.focus();
    }

    openBtn.addEventListener('click', open);
    $$('[data-nom-close]', root).forEach(function (b) { b.addEventListener('click', close); });
    ov.addEventListener('mousedown', function (e) { if (e.target === ov) close(); });
    document.addEventListener('keydown', function (e) {
      if (ov.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (sending) return;
      var nameEl = $('#rescueName', root), cityEl = $('#rescueCity', root);
      var name = nameEl.value.trim(), city = cityEl.value.trim();
      err.classList.remove('on');
      if (!name || !city) {
        err.textContent = 'Please add both the rescue name and the city.';
        err.classList.add('on');
        (name ? cityEl : nameEl).focus();
        return;
      }
      body.value = 'Rescue nomination\nRescue name: ' + name + '\nCity: ' + city;
      sending = true;
      submit.disabled = true;
      submit.textContent = 'Sending…';
      fetch(form.getAttribute('action'), { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } })
        .then(function (r) {
          /* Shopify redirects to ?contact_posted=true only when it accepted it */
          var posted = r.ok && ((r.url || '').indexOf('contact_posted=true') > -1 || r.redirected);
          if (!posted) throw new Error('not posted');
          wrap.hidden = true; done.hidden = false;
          var b = $('[data-nom-close]', done);
          if (b) b.focus();
        })
        .catch(function () {
          sending = false;
          submit.disabled = false;
          submit.textContent = 'Send nomination';
          err.textContent = 'Something went wrong. Please try again.';
          err.classList.add('on');
        });
    });
  }());
}());
